import { EventSponsorGroupFormData } from '~admin/view/components/details/sponsor-details/sponsor-details-group.component';
import { EventSponsorDetailsFromData } from '~admin/view/components/details/sponsor-details/sponsor-details.component';
import { EventProfileCreateRequest } from '~client/model/admin/event-profile-create-request';
import { EventSponsorGroupRequest } from '~client/model/admin/event-sponsor-group-request';
import { isNilOrEmpty } from '~common/helper/global';

/**
 * Transforms EventSponsorDetailsFormData to Partial<EventProfileCreateRequest>
 * @param values
 */
export const getEventSponsorDetailsRequest = (
  values: EventSponsorDetailsFromData,
): Pick<EventProfileCreateRequest, 'sponsorGroups'> | null => {
  const { sponsorGroups } = values;

  if (isNilOrEmpty(sponsorGroups)) {
    return { sponsorGroups: null };
  }

  const eventSponsorGroupsRequest: EventSponsorGroupRequest[] = sponsorGroups.map(
    (group: EventSponsorGroupFormData) => ({
      height: group.height,
      sponsorIds: group.sponsors?.map((sponsor) => sponsor.id),
    }),
  );

  return { sponsorGroups: eventSponsorGroupsRequest };
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/event-profile-request/event-sponsor-details-request.helper.ts